import {useRef} from 'react'
import {TreatmentRequestExtended} from '@/features/treatment-requests/types'
import {ScrollArea} from '@/components/ui/scroll-area/ScrollArea'
import {Scrollbar} from '@/components/ui/scrollbar/Scrollbar'
import {DetailsInformationWarningsBanner} from '@/components/commons/details-information-warnings-banner/DetailsInformationWarningBanner'
import {PatientSection} from '@/features/patients/components/patient-section/PatientSection.tsx'
import {TreatmentRequestEditableSections} from '@/features/treatment-requests/components/treatment-request-editable-sections/TreatmentRequestEditableSections'
import {useTreatmentRequestDetailsStore} from '@/features/treatment-requests/store/treatmentRequestDetailsStore'
import {BannerAlert} from '@/components/commons/banner-alert/BannerAlert'
import {Divider} from '@/components/ui/divider/Divider'
import {DetailsFieldsSection} from '@components/ui/details-atoms/DetailsAtoms.tsx'
import {useTranslation} from '@/translations/i18n.tsx'
import {useOutletContext} from 'react-router-dom'
import {ScrollProvider, useScrollContext} from '@/hooks/useScrollContext'
import {Helmet} from 'react-helmet'

export const TreatmentRequestDetailsSections = () => {
    return (
        <ScrollProvider>
            <TreatmentRequestDetailsContent />
        </ScrollProvider>
    )
}

const TreatmentRequestDetailsContent = () => {
    const {t} = useTranslation()
    const {treatmentRequest} = useOutletContext<{treatmentRequest: TreatmentRequestExtended}>()
    const errorBannerRef = useRef<HTMLDivElement>(null)
    const isErrorBannerVisible = useTreatmentRequestDetailsStore(state => state.isErrorBannerVisible)
    const setIsErrorBannerVisible = useTreatmentRequestDetailsStore(state => state.setIsErrorBannerVisible)
    const {scrollContainerRef} = useScrollContext()

    return (
        <>
            <Helmet title={t('treatment_requests:details_meta_title', {number: treatmentRequest.code})} />
            <div style={{overflow: 'hidden'}}>
                <ScrollArea
                    style={{height: '100%'}}
                    scrollbar={<Scrollbar />}
                    viewportProps={{ref: scrollContainerRef}}
                >
                    {isErrorBannerVisible && (
                        <>
                            <BannerAlert ref={errorBannerRef} onClose={() => setIsErrorBannerVisible(false)} />
                            <Divider direction="horizontal" />
                        </>
                    )}

                    {treatmentRequest.fieldsToCompile.length > 0 && (
                        <DetailsInformationWarningsBanner fieldsToCompile={treatmentRequest.fieldsToCompile} />
                    )}
                    <DetailsFieldsSection title={t('commons:patient')} bodyWidth="100%">
                        <PatientSection patientId={treatmentRequest.patientId} />
                    </DetailsFieldsSection>
                    <TreatmentRequestEditableSections />
                </ScrollArea>
            </div>
        </>
    )
}
